module.exports = "/_next/static/files/768b328c0266356fe847669281e2d66d.png";